import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  style: {"enable-background":"new 0 0 122.9 107.5"},
  viewBox: "0 0 122.9 107.5"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M3.9 7.9C1.8 7.9 0 6.1 0 3.9 0 1.8 1.8 0 3.9 0h10.6c3.6.1 6.8.8 9.5 2.5 3 1.9 5.2 4.8 6.4 9.1 0 .1 0 .2.1.3l1 4H119c2.2 0 3.9 1.8 3.9 3.9 0 .4-.1.8-.2 1.2l-10.2 41.1c-.4 1.8-2 3-3.8 3h-64c1.4 5.2 2.8 8 4.7 9.3 2.3 1.5 6.3 1.6 13 1.5H107.7c2.2 0 3.9 1.8 3.9 3.9 0 2.2-1.8 3.9-3.9 3.9H62.5c-8.3.1-13.4-.1-17.5-2.8-4.2-2.8-6.4-7.6-8.6-16.3L23 13.9c0-.1 0-.1-.1-.2-.6-2.2-1.6-3.7-3-4.5-1.4-.9-3.3-1.3-5.5-1.3H3.9zM96 88.3c5.3 0 9.6 4.3 9.6 9.6s-4.3 9.6-9.6 9.6-9.6-4.3-9.6-9.6 4.3-9.6 9.6-9.6zm-42.1 0c5.3 0 9.6 4.3 9.6 9.6s-4.3 9.6-9.6 9.6-9.6-4.3-9.6-9.6 4.3-9.6 9.6-9.6zM33.7 23.7l8.9 33.5h63.1l8.3-33.5H33.7z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }